var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"light"},on:{"click":function($event){return _vm.back()}}},[_vm._v(" Cancel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }